module.exports = __webpack_public_path__ + "static/maps-section-cloud-4-d9be209a962151b36887cd22aeb8915b.png";